const formStepperInitialState = {
    activeStep: 0,
    steps: [
        {
            completed: false,
        },
        {
            completed: false,
        },
        {
            completed: false,
        },
        {
            completed: false,
        },
        {
            completed: false,
        },
        {
            completed: false,
        },
        {
            completed: false,
        },
        {
            completed: false,
        },
        {
            completed: false,
        },
        {
            completed: false,
        },
    ],
    isPending: false,
};

export default formStepperInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/formStepperInitialState.js